/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  FindCanonicalValueByOperationIdQueryResponse,
  FindCanonicalValueByOperationIdPathParams,
} from "../types/FindCanonicalValueByOperationId.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const findCanonicalValueByOperationIdQueryKey = (
  operationId:
    | FindCanonicalValueByOperationIdPathParams["operationId"]
    | undefined
) =>
  [
    {
      url: "/v1/datapoint/find-canonical-value/operation/:operationId",
      params: { operationId: operationId },
    },
  ] as const

export type FindCanonicalValueByOperationIdQueryKey = ReturnType<
  typeof findCanonicalValueByOperationIdQueryKey
>

/**
 * @summary Resolve canonical datapoint value for an operation
 * {@link /v1/datapoint/find-canonical-value/operation/:operationId}
 */
export async function findCanonicalValueByOperationId(
  operationId: FindCanonicalValueByOperationIdPathParams["operationId"],
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindCanonicalValueByOperationIdQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/datapoint/find-canonical-value/operation/${operationId}`,
    ...requestConfig,
  })
  return res
}

export function findCanonicalValueByOperationIdQueryOptions(
  operationId:
    | FindCanonicalValueByOperationIdPathParams["operationId"]
    | undefined,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = findCanonicalValueByOperationIdQueryKey(operationId)
  return queryOptions<
    ResponseConfig<FindCanonicalValueByOperationIdQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindCanonicalValueByOperationIdQueryResponse>,
    typeof queryKey
  >({
    enabled: !!operationId,
    queryKey,
    queryFn: async ({ signal }) => {
      return findCanonicalValueByOperationId(operationId!, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary Resolve canonical datapoint value for an operation
 * {@link /v1/datapoint/find-canonical-value/operation/:operationId}
 */
export function useFindCanonicalValueByOperationId<
  TData = ResponseConfig<FindCanonicalValueByOperationIdQueryResponse>,
  TQueryData = ResponseConfig<FindCanonicalValueByOperationIdQueryResponse>,
  TQueryKey extends QueryKey = FindCanonicalValueByOperationIdQueryKey,
>(
  operationId:
    | FindCanonicalValueByOperationIdPathParams["operationId"]
    | undefined,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindCanonicalValueByOperationIdQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ??
    findCanonicalValueByOperationIdQueryKey(operationId)

  const query = useQuery(
    {
      ...findCanonicalValueByOperationIdQueryOptions(operationId, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
